import flatpickr from "flatpickr"
import { German } from "flatpickr/dist/l10n/de.js"

export const flatpickrLocale = (locale) => locale === "de" ? German : undefined

export default flatpickr
